<template>
  <div>
    <base-header type="gradient-default" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Mask -->
      <span class="mask bg-gradient-default opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/admin/trilha/cursos/' + $route.params.id + '/materiais'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para a listagem de materiais do curso"
              ><i class="fas fa-chevron-left mr-1 mb-4"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-8 col-md-10">
            <p class="text-white my-3">
              Aqui você definir a ordem de exibição e as seções dos materiais do
              curso. Ao estruturar os materiais de acordo com a ordem desejada,
              lembre-se de salvar as alterações.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid">
      <div class="col-lg-12">
        <card shadow type="secondary mt--7">
          <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
              <div class="col-12">
                <h3 class="mb-0">
                  <i class="fas fa-arrows-alt-v mr-2"></i> Ordenar materiais do
                  curso <span class="text-warning">{{ course.title }}</span>
                </h3>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="row" ref="materiais_table">
              <div
                :class="{
                  'col-xl-6 mb-4': materials.sections.length !== 1,
                  'col-xl-12 mb-4': materials.sections.length === 1,
                }"
              >
                <card type="secondary">
                  <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 class="mb-0">
                          Lista de materiais
                          <span class="text-warning">sem seção</span>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <Container
                    group-name="material"
                    @drop="onDrop(withoutSectionId, $event)"
                    @drag-start="dragStart(withoutSectionId, $event)"
                    :get-child-payload="getChildPayload"
                  >
                    <Draggable
                      v-for="(material, index) in materials.withoutSection"
                      :key="index"
                    >
                      <div class="draggable-item">
                        <span class="column-drag-handle cursor pr-4 float-left"
                          ><i class="fas fa-bars text-gray"> </i
                        ></span>
                        <b>{{ material.order }}º</b>.
                        {{ truncate(material.title, 50) }}
                        <span class="float-right">
                          <base-button
                            type="white"
                            size="sm"
                            @click="handleOpenModalView(material)"
                            class="text-primary"
                            v-tooltip.bottom="'Visualizar conteúdo'"
                          >
                            <i class="fas fa-eye"></i>
                          </base-button>
                        </span>
                      </div> </Draggable
                  ></Container>
                </card>
              </div>
              <div
                class="col-xl-6 mb-4"
                v-for="(section, index) in materials.sections"
                :key="index"
              >
                <card type="secondary" v-if="index !== withoutSectionId">
                  <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 class="mb-0">
                          <span class="text-success">{{ index + 1 }}. </span>
                          <span class="text-default">{{ section.title }}</span>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <Container
                    group-name="material"
                    @drop="onDrop(index, $event)"
                    @drag-start="dragStart(index, $event)"
                    :get-child-payload="getChildPayload"
                  >
                    <Draggable
                      v-for="(material, mIndex) in section.material"
                      :key="mIndex"
                    >
                      <div class="draggable-item">
                        <span class="column-drag-handle cursor pr-4 float-left"
                          ><i class="fas fa-bars text-gray"> </i
                        ></span>
                        <b>{{ material.order }}º.</b>
                        {{ truncate(material.title, 50) }}
                        <span class="float-right">
                          <base-button
                            type="white"
                            size="sm"
                            @click="handleOpenModalView(material)"
                            class="text-primary"
                            v-tooltip.bottom="'Visualizar conteúdo'"
                          >
                            <i class="fas fa-eye"></i>
                          </base-button>
                        </span>
                      </div> </Draggable
                  ></Container>
                </card>
              </div>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="warning"
              class="mt-3"
              :custom="true"
              @click="loadMaterials"
              >Cancelar alterações</base-button
            ><base-button
              type="success"
              class="mt-3"
              :custom="true"
              @click="modalConfirmation.show = true"
              >Salvar alterações</base-button
            >
          </div>
        </card>
      </div>
    </div>
    <modal
      :show.sync="modalView.show"
      modal-classes="modal-dialog-centered modal-lg"
      body-classes="pb-0"
      header-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Detalhes do material
      </h6>
      <div class="text-center">
        <i
          :class="['fas fa-3x', contentTypes[modalView.material.content].icon]"
          v-if="modalView.material"
        />
        <h3 class="mt-3">
          {{ modalView.material.title }}
        </h3>
        <p class="description mt-1 mb-0">
          {{ modalView.material.description }}
        </p>
        <p v-if="!modalView.material.is_active" class="mt-2">
          <badge type="warning" v-tooltip="'O material está oculto'"
            >Oculto</badge
          >
        </p>
        <div class="mt-4" v-if="modalView.material.content === 'file'">
          <base-button
            type="primary"
            @click="openLink(modalView.material.file_url)"
            >Visualizar arquivo
          </base-button>
        </div>
        <div class="mt-4" v-else-if="modalView.material.content === 'link'">
          <p class="mb-0 text-break" v-if="modalView.material.link">
            {{ modalView.material.link }}
          </p>
          <base-button
            type="primary mt-2"
            @click="openLink(modalView.material.link)"
          >
            Abrir link externo do material
          </base-button>
        </div>
        <div class="mt-4" v-else-if="modalView.material.content === 'text'">
          <div class="ml-container-read-only">
            <quill-editor
              v-if="modalView.material.text"
              v-model="modalView.material.text"
              :options="editorReadOnly"
              disabled="disabled"
              class="border rounded"
            ></quill-editor>
          </div>
        </div>
        <div
          class="mt-4"
          v-else-if="modalView.material.content === 'evaluation'"
        >
          <div
            v-for="(question, index) in modalView.material.evaluation"
            :key="index"
            class="text-left"
          >
            <h4>Questão {{ index + 1 }} - {{ question.title }}</h4>
            <p class="description ml-2" v-if="question.description">
              <span class="font-weight-bold">Descrição: </span
              >{{ question.description || "-" }}
            </p>
            <p class="description ml-2">
              <span class="font-weight-bold">Tipo de questão: </span>
              {{ question.type_name }}
            </p>
            <div v-if="question.type !== 'text'" class="ml-2">
              <p class="description mb-0">
                <span class="font-weight-bold">Alternativas: </span>
              </p>
              <ul class="ml-3 description list-unstyled">
                <li
                  v-for="(option, index) in question.options"
                  :key="'op_' + index"
                >
                  <i
                    class="fas fa-angle-right mr-1"
                    v-if="question.right_answer === ''"
                  />
                  <i
                    class="fas fa-check text-success mr-1"
                    v-tooltip="'Alternativa correta'"
                    v-else-if="question.right_answer.includes(String(index))"
                  />
                  <i
                    class="fas fa-times text-danger mr-1"
                    v-tooltip="'Alternativa incorreta'"
                    v-else
                  />
                  {{ option.title }}
                </li>
              </ul>
            </div>
            <hr class="mt-3 mb-4" />
          </div>
        </div>
        <div class="mt-4" v-else-if="modalView.material.content === 'video'">
          <iframe
            width="100%"
            height="350"
            :src="`https://www.youtube.com/embed/${getYoutubeVideoId(
              modalView.material.video
            )}`"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; clipboard-write"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="dark"
          class="ml-auto"
          @click="modalView.show = false"
        >
          Voltar
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modalConfirmation.show"
      modal-classes="modal-default modal-dialog-centered"
      body-classes="pb-2"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_sort">
        <div class="text-center">
          <i class="fas fa-arrows-alt-v fa-3x mr-3" />
          <i class="fas fa-book fa-3x" />
          <h4 class="heading mt-4">Confirmar alterações</h4>
          <p class="mt-3">
            Você confirma a alteração da
            <span class="font-weight-bold">ordem de exibição</span> dos
            materiais?
          </p>
        </div>
        <base-alert
          type="danger"
          class="text-center mb-2"
          v-if="modalConfirmation.error"
          >Ocorreu um erro ao ordenar os materiais. Por favor, tente
          novamente.</base-alert
        >
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modalConfirmation.show = false"
        >
          Voltar
        </base-button>
        <base-button type="white text-success" @click="handleSubmitSort">
          Confirmar alterações
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

import { getIdFromUrl } from "vue-youtube";

import { Draggable, Container } from "vue-smooth-dnd";

import api from "@/services/api";

export default {
  name: "materiais_list",
  components: {
    quillEditor,
    Draggable,
    Container,
  },
  data() {
    return {
      materials: {
        sections: [],
        withoutSection: [],
      },
      course: "",
      modalView: {
        show: false,
        material: "",
      },
      modalConfirmation: {
        show: false,
        error: "",
      },
      contentTypes: {
        video: { name: "Vídeo do YouTube", icon: "fa-play" },
        file: { name: "Arquivo", icon: "fa-file-alt" },
        link: { name: "Link externo", icon: "fa-external-link-alt" },
        text: { name: "Texto", icon: "fa-paragraph" },
        evaluation: { name: "Avaliação", icon: "fa-tasks" },
      },
      questionTypes: [
        {
          type: "radiobox",
          name: "Múltipla escolha",
        },
        { type: "checkbox", name: "Caixas de seleção" },
        { type: "text", name: "Texto" },
      ],
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble",
      },
      draggingMaterial: "",
      draggingCard: {
        section: "",
        index: -1,
        data: {},
      },
      withoutSectionId: -1,
    };
  },
  async mounted() {
    await this.loadMaterials();
  },
  methods: {
    openLink(link) {
      window.open(link, "file-window", "resizable=1,height=750,width=750");
    },
    getAllMaterials() {
      let allMaterials = [];
      if (this.materials.sections) {
        this.materials.sections.forEach((section) => {
          section.material.forEach((material) => {
            allMaterials.push({
              material_id: material.id,
              section_id: material.section_id,
              order: material.order,
            });
          });
        });
        return allMaterials;
      }
    },
    setOrder() {
      for (let section of this.materials.sections) {
        let i = 1;
        for (let material of section.material) {
          material.order = i;
          i++;
        }
      }
    },
    async handleOpenModalView(material) {
      if (material.content === "evaluation") {
        this.formatQuestion(material);
      }
      this.modalView.material = material;
      this.modalView.show = true;
    },
    async handleSubmitSort() {
      const loader = this.$loading.show({
        container: this.$refs.modal_sort,
        width: 90,
        height: 90,
        opacity: 0,
      });
      this.modalConfirmation.error = "";
      try {
        let materialsData = {
          materials: [],
        };
        materialsData.materials = this.getAllMaterials();
        const { data } = await api.put(
          `/admin/courses/${this.$route.params.id}/order`,
          materialsData
        );
        this.tableData = data;
        this.$toasted.success("Materiais ordenados com sucesso!");
        this.modalConfirmation.show = false;
      } catch (e) {
        this.modalConfirmation.error = true;
        this.$toasted.error("Ocorreu um erro ao ordenar os materiais");
      } finally {
        loader.hide();
      }
    },
    async loadMaterials() {
      const loader = this.$loading.show({
        container: this.$refs.materiais_table,
        width: 110,
        height: 110,
        opacity: 0,
      });
      try {
        const { data } = await api.get(
          `/admin/courses/${this.$route.params.id}/materials`
        );
        this.course = data.course;
        if (data.hasOwnProperty("with_section") && data.with_section.length)
          this.materials.sections = data.with_section;
        this.withoutSectionId = data.with_section.length;
        if (
          data.hasOwnProperty("without_section") &&
          data.without_section.length
        ) {
          let withoutSection = {
            title: "Sem seção",
            material: [],
          };
          this.materials.withoutSection = data.without_section;
          withoutSection.material = data.without_section;
          this.materials.sections.push(withoutSection);
          this.withoutSectionId = this.materials.sections.length - 1;
          this.setOrder();
        }
        loader.hide();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar os materiais do curso"
        );
      }
    },
    truncate(text, stop = 30, clamp = "...") {
      if (!text) return "N/A";
      return text.slice(0, stop) + (stop < text.length ? clamp : "");
    },
    onDrop(section, dropResult) {
      const { removedIndex, addedIndex } = dropResult;
      if (
        section === this.draggingCard.section &&
        removedIndex === addedIndex
      ) {
        return;
      }
      if (removedIndex !== null) {
        this.materials.sections[section].material.splice(removedIndex, 1);
      }
      if (addedIndex !== null) {
        this.materials.sections[section].material.splice(
          addedIndex,
          0,
          this.draggingCard.data
        );
      }
      this.materials.sections.map(function (section) {
        section.material.map(function (m, mIndex) {
          m.section_id = section.id;
          m.order = mIndex + 1;
          return m;
        });
      });
    },
    dragStart(section, dragResult) {
      const { payload, isSource } = dragResult;
      if (isSource) {
        this.draggingCard = {
          section,
          index: payload,
          data: {
            ...this.materials.sections[section].material[payload],
          },
        };
      }
    },
    getChildPayload(index) {
      return index;
    },
    formatQuestion(material) {
      for (const question of material.evaluation) {
        if (question.parsed) continue;
        const contentIndex = this.questionTypes.findIndex(
          (item) => item.type === question.type
        );
        Object.assign(question, {
          type: this.questionTypes[contentIndex].type,
          type_name: this.questionTypes[contentIndex].name,
          parsed: true,
        });
        if (["radiobox", "checkbox"].includes(question.type)) {
          question.options = JSON.parse(question.options);
          if (question.right_answer !== "")
            question.right_answer = question.right_answer.split(",");
        }
      }
    },
    getYoutubeVideoId(url) {
      return getIdFromUrl(url);
    },
  },
};
</script>
<style scoped>
.cursor {
  cursor: pointer;
}

.card-img-top {
  height: 200px;
  margin: auto;
  object-fit: cover;
}

.card-image {
  position: relative;
  height: 200px;
}

.image-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0.2;
  transition: 0.5s ease;
  background: rgba(0, 0, 0, 0.5);
}

.card:hover .image-overlay {
  opacity: 1;
}

.draggable-item {
  background: #fff;
  color: #8e919b;
  padding: 1.5rem;
  border-bottom: 1px solid #dee2e6;
  border-radius: 10px;
  margin: 0.3rem;
}
</style>

<style>
.nv-container-read-only .quill-editor .ql-container,
.nv-container-read-only .quill-editor .ql-container .ql-editor {
  min-height: 5rem;
  max-height: 10rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
